// ArtistCredit is the lightweight id+title shape the API embeds wherever a
// track or album lists the artist(s) credited on it (see Track.artists /
// Album.artists) - distinct from the full Artist model below, which is only
// fetched for an artist's own detail page.
export interface ArtistCredit {
    id: number;
    title: string;
}

export function artistCreditsFromJson(json: any): ArtistCredit[] {
    if (!Array.isArray(json)) {
        return [];
    }
    return json.map((a: any) => ({ id: a.id, title: a.title }));
}

export class Artist {
    private id: number;
    private title: string;
    private description: string;
    private mbid: string;
    private origin: string;
    private begin: string;

    constructor(id: number, title: string, description: string, mbid: string, origin: string, begin: string) {
        this.id = id;
        this.title = title;
        this.description = description;
        this.mbid = mbid;
        this.origin = origin;
        this.begin = begin;
    }

    public getId(): number {
        return this.id;
    }

    public getTitle(): string {
        return this.title;
    }

    public getDescription(): string {
        return this.description;
    }

    public getMbid(): string {
        return this.mbid;
    }

    public getOrigin(): string {
        return this.origin;
    }

    public getBegin(): string {
        return this.begin;
    }

    public static fromJson(json: any): Artist {
        return new Artist(
            json.id,
            json.title,
            json.description ?? '',
            json.mbid ?? '',
            json.origin ?? '',
            json.begin ?? ''
        );
    }
}
